import { find, isEmpty, map, some } from "lodash-es";
import { authState } from "./AuthState.svelte";
import { UsersApi } from "$lib/api/";
import { parseBool } from "../shared/utils/lodash-extensions";
import { Identity } from "$lib/shared/services/IdentityService";

export let userState = $state({
    user: {},
    tenants: [],
    role: {},
    isAdmin: false,
    isGlobalAdmin: false,
    defaultTenant: null,
    totalCount: 0
});

export async function getUserData(forceRefresh=false) {
    if(!forceRefresh && !isEmpty(userState?.user))
        return $state.snapshot(userState);

    let { user, tenants } = await UsersApi.getCurrentUserData();
    userState.user = user;
    userState.tenants = tenants;
    userState.defaultTenant = find(tenants, t => t.tenantId === user.defaultTenantId);
    userState.role = user.roles[0];
    userState.isAdmin = some(user.roles, "isAdministrator");
    userState.isGlobalAdmin = userState.isAdmin && some(tenants, "isGlobal");

    return $state.snapshot(userState);
}

export function getDefaultClientId() {
    let sessionClientId = sessionStorage.getItem(Identity.TENANT_CLIENT_ID_SESSION_KEY);
    return isEmpty(sessionClientId) || !some(userState.tenants, t => t.clientId === sessionClientId)
        ? userState.defaultTenant.clientId
        : sessionClientId;
}

//This will be refined further once group/admin permissions are sorted out
export function isActiveAdminRole(role) {
    let userRole = find(userState.roles, r => r.roleId === role?.roleId);
    // if it's the global admin group or the group associated with the current tenant and is
    // assigned to the current user, unchecking could cause unexpected behavior
    return role?.tenantId === authState.currentTenant?.tenantId
        && (authState.currentTenant?.isGlobal || userRole?.isAdministrator);
}

export async function refreshUserData(clientId=null) {
    let { tenants } = await getUserData(true);

    if(!isEmpty(clientId))
        authState.currentTenant = find(tenants, t => t.clientId === clientId);

    return $state.snapshot(userState);
}
